import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';
import constants from '../constants';
import { add, remove } from './../Actions/ShoppingList.action';
import { translate } from '../Services/translation';
import { googleAnalytics } from '../Services/googleAnalytics';

const ReorderButton = ({ productId, isSmall, isSticky, onClick }) => {
    const shoppingList = useSelector((x) => x.shoppingList);

    return (
        <button
            className={`shoppinglist__button ${isSmall ? 'shoppinglist__button--small' : ''
                } ${isSticky ? 'shoppinglist__button--sticky' : ''} ${constants.isClickAndCollect ? 'shoppinglist__button--green' : ''}`}
            onClick={() => onClick({ productId, shoppingList })}
            aria-label={translate('button.addToShoppingList')}
        >
            {isSmall && !shoppingList.some((x) => x.productId == productId) && (
                <img 
                    src="/ui/images/heart.svg" 
                    className="shoppinglist__icon" 
                    alt="favorite-icon" 
                />
            )}
            {isSmall && shoppingList.some((x) => x.productId == productId) && (
                <img 
                    src="/ui/images/heart-filled.svg" 
                    className="shoppinglist__icon" 
                    alt="filled-favorite-icon" 
                />
            )}
            {!isSmall && translate('button.addToShoppingList')}
        </button>
    );
};

function isJSONString(obj){
    try {
        JSON.parse(obj)
        return true
    } catch (error) {
        return false
    }
}

const StyledButton = (props) => {
    const dispatch = useDispatch();
    const onClick = ({ productId, shoppingList }) => {
        try {
            if (!shoppingList.some((x) => x.productId == productId)) {
                let jsonObject = props.product
                if(isJSONString(props.product)){
                    jsonObject = JSON.parse(props.product)
                }
                dispatch(add(productId));
                googleAnalytics({
                    'event': 'addToWishlist',
                    'ecommerce': {
                        'currencyCode': jsonObject.Currency.Id,
                        'add': {
                            'products': [{
                                'name': jsonObject.Name,
                                'id': jsonObject.Id,
                                'price': jsonObject.Price.Price.Price,
                                'priceWithVat': jsonObject.Price.Price.PriceWithVat,
                                'quantity': 1
                            }]
                        }
                    }
                })
            } else {
                dispatch(remove(productId));
            }
            return true;
        } catch (ex) {
            return false;
        }
    };
    const Button = withReactiveStyleBuyButton(
        ReorderButton,
        onClick,
        `shoppinglist__btn__outer`
    );
    return <Button {...props} />;
};
export default StyledButton;
